export const schoolPickerMixin = {
  data() {
    return { options: [], model: {} };
  },
  mounted() {
    this.search();
  },
  methods: {
    // @vuese
    // Wyszukuje szkoły
    search(search) {
      this.$store
        .dispatch('structureNode/list', {
          search,
          hasParentOrChildren: true,
          filterFields: { isGuided: this.public }
        })
        .then(result => (this.options = this.processSearchResult(result.list, search)));
    },
    // @vuese
    // Przetwarza wyniki wyszukiwania
    processSearchResult(list, search) {
      return list;
    }
  }
};
